const PORTFOLIO_AMOUNT_LABEL_ALT = {
  insuredAmount: 'insuredAmount',
  remainingCapital: 'remainingCapital',
}

export const PORTFOLIO_AMOUNT_LABEL = {
  temporaire_deces: PORTFOLIO_AMOUNT_LABEL_ALT.insuredAmount,
  vie_entiere: PORTFOLIO_AMOUNT_LABEL_ALT.insuredAmount,
  capital_differe: PORTFOLIO_AMOUNT_LABEL_ALT.insuredAmount,
  convention_obseques: PORTFOLIO_AMOUNT_LABEL_ALT.insuredAmount,
  contrat_prevoyance_individuelle: PORTFOLIO_AMOUNT_LABEL_ALT.insuredAmount,
  sans_credit_dimpot: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_dimpot_acquisition_rp_dans_le_neuf:
    PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_dimpot_acquisition_rp_dans_le_vieux:
    PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_dimpot_batiment_basse_consommation:
    PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_biens_dusage: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_biens_de_rapport: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_scpi_et_sci: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_autres_biens_immobiliers: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_droits_sociaux: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_fonds_de_commerce: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_immobilier_professionnel: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_autres_biens_professionnels:
    PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_a_la_consommation: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_facilites_de_tresorerie: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_dettes_fiscales: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_dettes_familiales: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
  credit_autres_dettes_diverses: PORTFOLIO_AMOUNT_LABEL_ALT.remainingCapital,
}
